// Front-end feature flags — flip to toggle features without deleting code.
//
// INSIGHTS_AI_READS_ENABLED gates the on-demand AI panels on the Insights pages:
//   • "Market read"       (Market Overview tab)
//   • "Geopolitical read" (Geopolitical Alignment tab)
// Hidden for now; set to true to bring both back. All supporting state, handlers
// and endpoints stay intact so re-enabling is a one-line change.
export const INSIGHTS_AI_READS_ENABLED = false;

// SHOW_YOY_VIEW_ENABLED gates the "Year on Year" view on the Insights show
// drill-down — the edition toggle and the ShowYoYDashboard it renders. Hidden
// for now; set to true to bring it back. ShowYoYDashboard and the data it reads
// are untouched, so re-enabling is a one-line change.
export const SHOW_YOY_VIEW_ENABLED = false;
